import { IntlShape, MessageDescriptor } from 'react-intl';

import {
  ADD_MESSAGE,
  DEFAULT_ERROR_MESSAGE,
  DEFAULT_VARIANT,
  NETWORK_ERROR_MESSAGE,
  REMOVE_MESSAGE,
} from './constants';
import messages from './messages';

/** Axios interceptor rejects these exact strings; central map so new sentinels need one entry here (OCP). */
const FLASH_CAUGHT_STRING_TO_I18N: ReadonlyMap<string, MessageDescriptor> =
  new Map([
    [NETWORK_ERROR_MESSAGE, messages.networkError],
    [DEFAULT_ERROR_MESSAGE, messages.defaultError],
  ]);

export type Variant = 'error' | 'warning' | 'info' | 'success';

let messageId = 0;

export function addMessageAction(
  text: string,
  variant: Variant = DEFAULT_VARIANT,
  autoClose = true,
) {
  messageId += 1;
  return {
    type: ADD_MESSAGE,
    text,
    variant,
    autoClose,
    id: messageId,
  };
}

export function removeMessageAction(id: number) {
  return {
    type: REMOVE_MESSAGE,
    id,
  };
}

/**
 * Prefer the i18n-ready `addDefaultErrorMessageActionI18n` instead
 * @deprecated
 */

export function addDefaultErrorMessageAction() {
  return addMessageAction(DEFAULT_ERROR_MESSAGE, 'error');
}

export function addDefaultErrorMessageActionI18n(intl: IntlShape) {
  return addMessageAction(intl.formatMessage(messages.defaultError), 'error');
}

export function addNetworkErrorMessageActionI18n(intl: IntlShape) {
  return addMessageAction(intl.formatMessage(messages.networkError), 'error');
}

function resolveCaughtErrorToUserMessage(
  error: unknown,
  intl: IntlShape,
): string {
  if (typeof error === 'string') {
    const descriptor = FLASH_CAUGHT_STRING_TO_I18N.get(error);
    if (descriptor) {
      return intl.formatMessage(descriptor);
    }
    const t = error.trim();
    if (t.length > 0) {
      return t;
    }
    return intl.formatMessage(messages.defaultError);
  }
  if (error instanceof Error && error.message.trim().length > 0) {
    return error.message.trim();
  }
  return intl.formatMessage(messages.defaultError);
}

/**
 * Prefer API/Axios message (e.g. JSON `error` / `message` from the axios interceptor),
 * otherwise the translated default error string.
 */
export function addErrorMessageFromCaughtValueI18n(
  error: unknown,
  intl: IntlShape,
) {
  return addMessageAction(
    resolveCaughtErrorToUserMessage(error, intl),
    'error',
  );
}
